import { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Icon } from '../../../shared/ui';
import { teamsModel, useTeamPermissions } from '../../../features/teams';
import { IconMap } from '../../../shared/sprite';
import {
  TEAM_SETTINGS_BRAND_ROUTE,
  TEAM_SETTINGS_INFO_ROUTE,
  TEAM_SETTINGS_MEMBERS_ROUTE,
  TEAM_SETTINGS_PERMISSIONS_CONTROL_ROUTE,
  TEAM_SETTINGS_SUBSCRIPTION_ROUTE,
  TEAM_SETTINGS_STYLES_ROUTE,
  TEAM_SETTINGS_INTEGRATIONS_ROUTE,
  TEAM_SETTINGS_CALL_RECORDINGS,
} from '../../../entities/history';

import { matchPath, useLocation } from 'react-router-dom';
import { redirectActions } from '../../../entities/history';
import { navigate } from '../../../processes/navigation';
import { WorkspaceNavigationItem } from './WorkspaceNavigationItem';

export const TeamSettingsNavigation: FC = () => {
  const location = useLocation();

  const dispatch = useDispatch();

  const currentTeam = useSelector(
    teamsModel.selectors.selectCurrentTeamWithError
  );

  const { isCanManageSubscription, isCanManageAccess, isOwner } =
    useTeamPermissions();

  const navigationInfo = [
    {
      id: 'workspace-settings',
      label: 'Workspace settings',
      icon: IconMap.WorkspaceSettings,
      route: TEAM_SETTINGS_INFO_ROUTE,
      isHide: false,
    },
    {
      id: 'permissions-control',
      label: 'Permission control',
      icon: IconMap.Shield02,
      route: TEAM_SETTINGS_PERMISSIONS_CONTROL_ROUTE,
      isHide: !isOwner,
    },
    {
      id: 'team-brand',
      label: 'Company information',
      icon: IconMap.BookClosed,
      route: TEAM_SETTINGS_BRAND_ROUTE,
      isHide: false,
    },
    {
      id: 'call-recordings',
      label: 'Call recording settings',
      icon: IconMap.HeadPhones02,
      route: TEAM_SETTINGS_CALL_RECORDINGS,
      isHide: false,
    },
    {
      id: 'team-branding',
      label: 'Branding',
      icon: IconMap.Palette,
      route: TEAM_SETTINGS_STYLES_ROUTE,
      isHide: false,
    },
    {
      id: 'members',
      label: 'Members',
      icon: IconMap.Members,
      route: TEAM_SETTINGS_MEMBERS_ROUTE,
      isHide: false,
    },
    {
      id: 'plans-billing',
      label: 'Plans & billing',
      icon: IconMap.Award,
      route: TEAM_SETTINGS_SUBSCRIPTION_ROUTE,
      isHide: !isCanManageSubscription,
    },
    {
      id: 'team-integrations',
      label: 'Team integrations',
      icon: IconMap.PuzzlePiece01,
      route: TEAM_SETTINGS_INTEGRATIONS_ROUTE,
      isHide: !isCanManageAccess,
    },
  ].filter((i) => !i.isHide);

  const currentRouteId = navigationInfo.find((item) =>
    matchPath(location.pathname, { path: item.route })
  )?.id;

  return (
    <>
      <Button
        color="link-gray"
        variant="icon-text"
        size="sm"
        onClick={() => {
          dispatch(redirectActions.toWorkspaceByBackUrl());
        }}
        className="!h-9 !px-3 !font-semibold md:hidden self-start mt-5"
      >
        <Icon glyph={IconMap.BackArrow} className="mr-2" />
        Back
      </Button>
      <div className="pl-3 text-lg font-bold text-gray-900 truncate">
        {currentTeam.name}
      </div>
      <div className="flex flex-col">
        {navigationInfo.map((item) => (
          <WorkspaceNavigationItem
            key={item.id}
            label={item.label}
            icon={item.icon}
            onClick={() =>
              dispatch(navigate({ to: item.route, isKeepQueryParams: true }))
            }
            isActive={item.id === currentRouteId}
          />
        ))}
      </div>
    </>
  );
};
